module.exports = __webpack_public_path__ + "img/logout.fade3c70.svg";